import script from "./MaterialLotDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialLotDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialLotDetailDialog.vue?vue&type=style&index=0&id=da2f2a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da2f2a6e"]])

export default __exports__